export default function customHtmlWidget(editor) {
  editor.DomComponents.addType('eb-custom-html', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-custom-html'
    },
    model: {
      defaults: {
        name: 'Custom HTML',
        tagName: 'div',
        droppable: false,
        attributes: {
          'data-gjs-type': 'eb-custom-html',
          'data-html-content': '<div style="padding:20px;background:#f9f9f9;border:2px dashed #ccc;border-radius:8px;text-align:center;color:#666;"><i class="fa fa-code" style="font-size:24px;margin-bottom:8px;display:block;"></i>Custom HTML Block<br/><small>Edit in Content tab</small></div>',
        },
        style: { 'padding': '5px' },
        components: '<div style="padding:20px;background:#f9f9f9;border:2px dashed #ccc;border-radius:8px;text-align:center;color:#666;"><i class="fa fa-code" style="font-size:24px;margin-bottom:8px;display:block;"></i>Custom HTML Block<br/><small>Edit in Content tab</small></div>',
        traits: [
          {
            type: 'text',
            name: 'data-html-content',
            label: 'HTML Code',
            changeProp: true,
          },
        ],
      },
      init() {
        this.on('change:attributes:data-html-content', this.updateContent)
      },
      updateContent() {
        const html = this.getAttributes()['data-html-content'] || ''
        this.components(html)
      },
      toHTML() {
        const html = this.getAttributes()['data-html-content'] || ''
        return html
      },
    },
  })

  editor.BlockManager.add('eb-custom-html', {
    label: 'Custom HTML',
    category: 'Utility',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z"/></svg>',
    content: { type: 'eb-custom-html' },
  })
}
